import { Button, Container, Divider, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import { blueGrey, grey } from "@material-ui/core/colors";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";
import Footer from "../Footer";
import SchoolPride from "../SchoolPride";
import graduation from "../../constants/images/Graduation-rafiki.png";
import { useHistory } from "react-router-dom";

import * as ROUTES from "../../constants/routes";
import { AuthUserContext, withAuthorization } from "../Session";
import { Android, Apple } from "@material-ui/icons";

const JustPassedModal = (props) => {
  const { firebase } = props;
  const { t } = useTranslation();
  const styles = useStyles();
  const history = useHistory();

  useEffect(() => {
    firebase.cancelActiveRescuerView();
  }, []);

  return (
    <AuthUserContext.Consumer>
      {(authUser) => (
        <Grid className={styles.mainContainer}>
          <SchoolPride time={3500} delay={750} />
          <Grid container className={styles.headerContainer}>
            <Container>
              <Grid container alignContent="center" justify="center" style={{ paddingBottom: 55 }}>
                <Grid item xs={12} md={authUser.sgpfc.alertAccess ? 7 : 12} className={styles.nameContainer}>
                  <Typography variant="h1" className={styles.mainTitle}>
                    {t("enhorabuena", { name: authUser.displayName })}
                  </Typography>

                  <Hidden smDown>
                    <DescriptionText />
                    <Grid className={styles.nextSteps} item xs={12} container direction="column">
                      <Grid item xs={10}>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ textTransform: "none", fontSize: "1.15rem", padding: "10px 24px", marginTop: 9 }}
                          onClick={() => history.push(ROUTES.HOME)}
                        >
                          {t("curso_Online")}
                        </Button>

                        {authUser.sgpfc.alertAccess && (
                          <Grid item xs={12} container direction="row">
                            <Grid item xs={6}>
                              <Button
                                variant="outlined"
                                fullWidth
                                color="secondary"
                                className={styles.downloadButton}
                                style={{ marginLeft: -3, marginTop: 16 }}
                                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.reanibex_alert", "_blank").focus()}
                              >
                                <Android style={{ fontSize: 42, marginRight: 9, color: blueGrey[400] }} />
                                {t("downloadreanibexAlert_ANDROID")}
                              </Button>
                            </Grid>
                            <Grid item xs={6}>
                              <Button
                                variant="outlined"
                                fullWidth
                                color="secondary"
                                className={styles.downloadButton}
                                style={{ marginTop: 16, margintle: 9 }}
                                onClick={() => window.open("https://apps.apple.com/es/app/reanibex-alert/id6445820800", "_blank").focus()}
                              >
                                <Apple style={{ fontSize: 42, marginRight: 9, color: blueGrey[400], marginLeft: -9 }} />
                                {t("downloadreanibexAlert_IOS")}
                              </Button>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Hidden>
                  <Hidden smUp>
                    <Typography className={styles.mainSubtitle}>{t("¡Ya eres rescatador/a activo/a de la comunidad!")}</Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <img src={graduation} style={{ width: "100%" }} />
                      </Grid>
                      {authUser.sgpfc.alertAccess && (
                        <Grid item xs={12}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            className={styles.downloadButton + " pulse"}
                            style={{ marginRight: 12 }}
                            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.reanibex_alert", "_blank").focus()}
                          >
                            <Android style={{ fontSize: 42, marginRight: 9, color: blueGrey[400] }} />
                            {t("downloadreanibexAlert_ANDROID")}
                          </Button>
                          <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            className={styles.downloadButton + " pulse"}
                            style={{ marginTop: 18 }}
                            onClick={() => window.open("https://apps.apple.com/es/app/reanibex-alert/id6445820800", "_blank").focus()}
                          >
                            <Apple style={{ fontSize: 38, marginRight: 9, color: blueGrey[400], marginLeft: -9 }} />
                            {t("downloadreanibexAlert_IOS")}
                          </Button>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <DescriptionText />
                      </Grid>

                      {authUser.sgpfc.alertAccess && (
                        <Grid item xs={12}>
                          <video width="100%" controls style={{ borderRadius: 16 }}>
                            <source
                              src={
                                "https://firebasestorage.googleapis.com/v0/b/reanibex-training.appspot.com/o/video%2FReanibexAlert_DEMO_Mayo_2020.mp4?alt=media&token=33bd126d-f233-4619-99d4-b0dba1cc7248"
                              }
                              type="video/mp4"
                            />
                          </video>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="secondary"
                          fullWidth
                          style={{ textTransform: "none", fontSize: "1.15rem", padding: "10px 24px", marginTop: 9 }}
                          onClick={() => {
                            window.scrollTo(0, 0);
                            history.push(ROUTES.HOME);
                          }}
                        >
                          {t("curso_Online")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Hidden>
                </Grid>

                {authUser.sgpfc.alertAccess && (
                  <Grid item xs={12} md={5} container spacing={2} direction="column" className={styles.CourseDetailContainer}>
                    <Hidden smDown>
                      <Divider orientation="vertical" style={{ marginRight: 16, marginLeft: 16 }} />
                    </Hidden>

                    <Grid item container direction="row" spacing={3}>
                      <Hidden xsDown>
                        <Grid item xs={12} container className={styles.badgeContainer} container direction="row" alignItems="center" spacing={3}>
                          <Grid item xs={12}>
                            <Typography variant="h6" className={styles.badgeTitle}>
                              Reanibex Alert demo
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <video width="100%" controls style={{ borderRadius: 16, zIndex: -1 }}>
                              <source
                                src={
                                  "https://firebasestorage.googleapis.com/v0/b/reanibex-training.appspot.com/o/video%2FReanibexAlert_DEMO_Mayo_2020.mp4?alt=media&token=33bd126d-f233-4619-99d4-b0dba1cc7248"
                                }
                                type="video/mp4"
                              />
                            </video>
                          </Grid>
                        </Grid>
                      </Hidden>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Container>
          </Grid>
          <div className={styles.footer} style={{ position: authUser.sgpfc.alertAccess && "absolute", bottom: 0, width: "100% " }}>
            <Footer />
          </div>
        </Grid>
      )}
    </AuthUserContext.Consumer>
  );
};

const DescriptionText = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Typography className={styles.mainSubtitle}>
      <AuthUserContext.Consumer>
        {(authUser) =>
          authUser.sgpfc.alertAccess
            ? t("Si aun no la has descargado, descarga la aplicación Reanibex Alert y descubre cuáles son los DEAs más cercanos de tu alrededor")
            : t("Gracias por formar parte de nuestra comunidad.Cada vez somos más las personas concienciadas en la cardio-protección, y es que ¡Juntos salvamos más vidas!")
        }
      </AuthUserContext.Consumer>
    </Typography>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(JustPassedModal);

const useStyles = makeStyles((theme) => ({
  footer: {
    [theme.breakpoints.down("sm")]: {
      position: "initial !important",
    },
  },
  mainContainer: {
    backgroundColor: grey[100],
  },
  nameContainer: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "-webkit-center",
    },
  },

  descriptionText: {
    backgroundColor: grey[100],
    textAlign: "initial",
    [theme.breakpoints.down("sm")]: {
      textAlign: "justify",
    },
  },

  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",
    marginBottom: 8,
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("sm")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },

  mainSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    marginRight: 9,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "80%",
    },
  },
  headerContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 20,
      paddingTop: 52,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 12,
      paddingTop: 20,
    },

    backgroundColor: "white",
    zIndex: -1,
    boxShadow: "0px 2px 3px -1px rgb(0 0 0 / 20%), 0 0px 0px rgba(0,0,0,0.24)",
  },
  CourseDetailContainer: {
    [theme.breakpoints.only("sm")]: {
      marginTop: 36,
    },
    [theme.breakpoints.only("xs")]: {
      marginTop: 0,
    },
  },

  detailContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 8,
    },
  },

  badgeTitle: {
    color: "#80868b",
    font: "500 12px/15.6px Google Sans,Arial,sans-serif",
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    paddingBottom: 16,
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },

  nextSteps: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 56,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 24,
    },
  },

  downloadButton: {
    textTransform: "none",
    fontSize: "1.15rem",
    padding: "10px 24px",
    marginTop: 9,

    [theme.breakpoints.up("sm")]: {
      marginLeft: 12,
    },
    [theme.breakpoints.down("sm")]: {},
  },
}));
